import React from 'react';
import { empresaData } from '../data/mock';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  const location = useLocation();

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      window.location.href = '/#' + sectionId;
      return;
    }
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  const goHome = () => {
    if (location.pathname !== '/') {
      window.location.href = '/';
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-200 shadow-sm">
      <div className="container mx-auto px-6 lg:px-10 max-w-7xl">
        <div className="flex items-center justify-between h-28">
          {/* Logo */}
          <button onClick={goHome} className="flex items-center cursor-pointer">
            <img 
              src={empresaData.logo} 
              alt="Micro-Bat Logo" 
              className="h-20 w-auto"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
            <div className="hidden items-center">
              <span className="text-2xl font-bold text-[#0d3b66]">MICRO-BAT</span>
              <span className="text-sm text-gray-500 ml-1">S.L.</span>
            </div>
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-6">
            <button 
              onClick={() => scrollToSection('inicio')}
              className="nav-link text-gray-700 hover:text-[#0d3b66] transition-colors"
            >
              Inicio
            </button>
            <button 
              onClick={() => scrollToSection('servicios')}
              className="nav-link text-gray-700 hover:text-[#0d3b66] transition-colors"
            >
              Servicios
            </button>
            <button 
              onClick={() => scrollToSection('nosotros')}
              className="nav-link text-gray-700 hover:text-[#0d3b66] transition-colors"
            >
              Nosotros
            </button>
            <button 
              onClick={() => scrollToSection('partners')}
              className="nav-link text-gray-700 hover:text-[#0d3b66] transition-colors"
            >
              Nuestras máquinas
            </button>
            <button 
              onClick={() => scrollToSection('contacto')}
              className="btn-primary"
            >
              Contacto
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-gray-700 p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col gap-4">
              <button 
                onClick={() => scrollToSection('inicio')}
                className="text-left text-gray-700 hover:text-[#0d3b66] py-2 transition-colors"
              >
                Inicio
              </button>
              <button 
                onClick={() => scrollToSection('servicios')}
                className="text-left text-gray-700 hover:text-[#0d3b66] py-2 transition-colors"
              >
                Servicios
              </button>
              <button 
                onClick={() => scrollToSection('nosotros')}
                className="text-left text-gray-700 hover:text-[#0d3b66] py-2 transition-colors"
              >
                Nosotros
              </button>
              <button 
                onClick={() => scrollToSection('partners')}
                className="text-left text-gray-700 hover:text-[#0d3b66] py-2 transition-colors"
              >
                Nuestras máquinas
              </button>
              <button 
                onClick={() => scrollToSection('contacto')}
                className="btn-primary w-full mt-2"
              >
                Contacto
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
